import { cloneDeep } from 'lodash';

const quillWrapperRegex =
  /^<p>(?:(?!<\/?p\b)[\s\S]|<\/?p(?!>)|<p>(?:(?!<\/?p\b)[\s\S])*<\/p>)*<\/p>$/;

// Weirdest shit I ever experienced
// https://ravnur.atlassian.net/browse/RMP-4128
export function fixQuillShit(origin: any, local: any) {
  const originClone = cloneDeep(origin);
  const localClone = cloneDeep(local);

  if (!originClone || !localClone) {
    return { originClone, localClone };
  }

  const originCloneDesc = originClone.description;
  const localCloneDesc = localClone.description;

  if (!originCloneDesc && !localCloneDesc) {
    return { originClone, localClone };
  }

  if (originCloneDesc.match(quillWrapperRegex) && !localCloneDesc.match(quillWrapperRegex)) {
    originClone.description = originCloneDesc.replace(/^<p>(.*)<\/p>$/, '$1');
  }

  if (localCloneDesc.match(quillWrapperRegex) && !originCloneDesc.match(quillWrapperRegex)) {
    localClone.description = localCloneDesc.replace(/^<p>(.*)<\/p>$/, '$1');
  }

  return { originClone, localClone };
}

export function clearHiddenCharacters(str: string) {
  // Regular expression to match hidden characters (whitespace and special characters)
  const regex = /[^\S\r\n]+/g;

  // Replace hidden characters with an empty string
  const cleanedStr = str.replace(regex, '');

  return cleanedStr;
}
